import AmericanExpress from './american-express.svg?react';
import ArrowRight from './arrow-right.svg?react';
import ArrowsSquare from './arrows-square.svg?react';
import AskForHelp from './ask-for-help.svg?react';
import AttentionCirclePrimary from './attention-circle-primary.svg?react';
import AttentionCircleRed from './attention-circle-red.svg?react';
import AttentionCircle from './attention-circle.svg?react';
import BigBurger from './big-burger.svg?react';
import BlockCenter from './block-center.svg?react';
import BlockLeft from './block-left.svg?react';
import BlockRight from './block-right.svg?react';
import BtnAddRemove from './btn-add-remove.svg?react';
import BurgerMenu from './burger-menu.svg?react';
import CancelCircleRed from './cancel-circle-red.svg?react';
import CancelItalics from './cancel-italics.svg?react';
import Cancel from './cancel.svg?react';
import CheckMarkCirclePrimary from './check-mark-circle-primary.svg?react';
import CheckMark from './check-mark.svg?react';
import Clip from './clip.svg?react';
import Copy from './copy.svg?react';
import DecreaseFontSize from './decrease-font-size.svg?react';
import Delete from './delete.svg?react';
import Discover from './discover.svg?react';
import DragAndDrop from './drag-and-drop.svg?react';
import EditCircle from './edit-circle.svg?react';
import EditItem from './edit-item.svg?react';
import Edit from './edit.svg?react';
import EyeOff from './eye-off.svg?react';
import Eye from './eye.svg?react';
import Facebook from './facebook.svg?react';
import Faq from './faq.svg?react';
import FolderAdd from './folder-add.svg?react';
import FolderBig from './folder-big.svg?react';
import FolderSmall from './folder-small.svg?react';
import Incline from './incline.svg?react';
import IncreaseFontSize from './increase-font-size.svg?react';
import Instagram from './instagram.svg?react';
import KeyboardArrowDownRound from './keyboard-arrow-down-round.svg?react';
import KeyboardArrowDown from './keyboard-arrow-down.svg?react';
import KeyBoardArrowLeft from './keyboard-arrow-left.svg?react';
import KeyBoardArrowRight from './keyboard-arrow-right.svg?react';
import KeyboardArrowUpDown from './keyboard-arrow-up-down.svg?react';
import KeyboardArrowUpRound from './keyboard-arrow-up-round.svg?react';
import KeyboardArrowUp from './keyboard-arrow-up.svg?react';
import KeyboardBackspaceLeft from './keyboard-backspace-left.svg?react';
import KeyboardBackspace from './keyboard-backspace.svg?react';
import KeyboardNew from './keyboard-new.svg?react';
import LayeringOver from './layering-over.svg?react';
import LayeringUnder from './layering-under.svg?react';
import LetterSpacing from './letter-spacing.svg?react';
import LinearGradientWide from './linear-gradient-wide.svg?react';
import LinearGradient from './linear-gradient.svg?react';
import LinkedIn from './linkedin.svg?react';
import Lock from './lock.svg?react';
import Logout from './logout.svg?react';
import MasterCard from './master-card.svg?react';
import Melody from './melody.svg?react';
import Minus from './minus.svg?react';
import Mouse from './mouse.svg?react';
import Pause from './pause.svg?react';
import Play from './play.svg?react';
import { default as Plus, default as RoundedPlus } from './plus.svg?react';
import PositionCenter from './position-center.svg?react';
import PositionLeft from './position-left.svg?react';
import PositionRight from './position-right.svg?react';
import Redo from './redo.svg?react';
import RestoreCirclePrimary from './restore-circle-primary.svg?react';
import Restore from './restore.svg?react';
import SearchBold from './search-bold.svg?react';
import Search from './search.svg?react';
import SecureRemove from './secure-remove.svg?react';
import Secure from './secure.svg?react';
import SettingsCircle from './settings-circle.svg?react';
import Settings from './settings.svg?react';
import StopPlay from './stop-play.svg?react';
import Trash from './trash.svg?react';
import Twitter from './twitter.svg?react';
import Undo from './undo.svg?react';
import UploadCirclePrimary from './upload-circle-primary.svg?react';
import Upload from './upload.svg?react';
import Upload2 from './upload2.svg?react';
import UserCircle from './user-circle.svg?react';
import Visa from './visa.svg?react';
import WhatsApp from './whatsapp.svg?react';
import YourLogo from './your-logo.svg?react';
import AskForHelpBold from './ask-for-help-bold.svg?react';

const iconComponents = {
  'ask-for-help': AskForHelp,
  faq: Faq,
  userCircle: UserCircle,
  'keyboard-arrow-up-round': KeyboardArrowUpRound,
  'keyboard-arrow-down-round': KeyboardArrowDownRound,
  search: Search,
  'keyboard-arrow-left': KeyBoardArrowLeft,
  'keyboard-arrow-right': KeyBoardArrowRight,
  'keyboard-arrow-up': KeyboardArrowUp,
  'keyboard-arrow-down': KeyboardArrowDown,
  delete: Delete,
  cancel: Cancel,
  'attention-circle-red': AttentionCircleRed,
  'attention-circle-primary': AttentionCirclePrimary,
  'cancel-circle-red': CancelCircleRed,
  restore: Restore,
  'check-mark-circle-primary': CheckMarkCirclePrimary,
  'restore-circle-primary': RestoreCirclePrimary,
  'keyboard-backspace-left': KeyboardBackspaceLeft,
  'check-mark': CheckMark,
  'upload-circle-primary': UploadCirclePrimary,
  secure: Secure,
  copy: Copy,
  'drag-and-drop': DragAndDrop,
  'edit-item': EditItem,
  edit: Edit,
  eye: Eye,
  'position-left': PositionLeft,
  'position-center': PositionCenter,
  'position-right': PositionRight,
  'linear-gradient': LinearGradient,
  'linear-gradient-wide': LinearGradientWide,
  minus: Minus,
  'rounded-plus': RoundedPlus,
  trash: Trash,
  'secure-remove': SecureRemove,
  clip: Clip,
  'decrease-font-size': DecreaseFontSize,
  'increase-font-size': IncreaseFontSize,
  redo: Redo,
  undo: Undo,
  mouse: Mouse,
  'eye-off': EyeOff,
  'burger-menu': BurgerMenu,
  lock: Lock,
  'block-left': BlockLeft,
  'block-center': BlockCenter,
  'block-right': BlockRight,
  'letter-spacing': LetterSpacing,
  incline: Incline,
  'folder-small': FolderSmall,
  'folder-big': FolderBig,
  'folder-add': FolderAdd,
  'keyboard-arrow-up-down': KeyboardArrowUpDown,
  'settings-circle': SettingsCircle,
  upload: Upload,
  'layering-under': LayeringUnder,
  'layering-over': LayeringOver,
  'your-logo': YourLogo,
  logout: Logout,
  settings: Settings,
  'arrow-right': ArrowRight,
  'arrows-square': ArrowsSquare,
  'cancel-italics': CancelItalics,
  'edit-circle': EditCircle,
  'american-express': AmericanExpress,
  discover: Discover,
  'master-card': MasterCard,
  visa: Visa,
  facebook: Facebook,
  instagram: Instagram,
  linkedin: LinkedIn,
  twitter: Twitter,
  stopPlay: StopPlay,
  play: Play,
  'btn-add-remove': BtnAddRemove,
  whatsapp: WhatsApp,
  'attention-circle': AttentionCircle,
  'keyboard-backspace': KeyboardBackspace,
  'keyboard-new': KeyboardNew,
  melody: Melody,
  pause: Pause,
  upload2: Upload2,
  plus: Plus,
  'big-burger': BigBurger,
  'search-bold': SearchBold,
  'ask-for-help-bold': AskForHelpBold,
};

export default iconComponents;
